module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAuUlEQVRYhe3XQQ6DIBAF0E/jgXoANj1J7QWInqSJF7A3ceO9xtDUjQsLk4FvjH/jhmQeEAfAlVNEgr9L8G/NXG5GCzAB6CT4kQXof982F+GMAHEbWgBr8Y8b5ldVgBZhCtAgzAG5iCKAHEQxQCqiKCAFURzwD1EFsIdwErzUQmzyRVi1YnX4W8AsXgVA/Q2pjYjaiqmHEfU4pl5IqFcybfEYq1a8vgmyisc0RoAHgKcb5j5h7JUDBcACCll0EcyQNJAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_btn_arrow2_sp@2x.png
// module id = 301
// module chunks = 0